import {
  Button,
  Modal,
  Form,
  Select,
  Input,
  message,
} from "antd";
import {
  EditOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { useState, useRef, useContext } from "react";
import { userStore } from "../../store/userStore";
import { useUpdateVoucherComment } from "../../hooks/voucher/voucherQuery";
import RefreshContext from "../../context/refreshContext";

const { TextArea } = Input;
const { Option } = Select;

function CommentEdit({ comment, voucher }) {
  const [isCommentEditOpen, setIsCommentEditOpen] = useState(false);
  const [whoToRecieveComment, setWhoToRecieveComment] = useState(
    comment.receiver,
  );

  const handleCommentEditOpen = () => setIsCommentEditOpen(true);
  const handleCommentEditClose = () => setIsCommentEditOpen(false);

  const contentRef = useRef(null);

  const { flag, setFlag } = useContext(RefreshContext);

  const updateVoucher = useUpdateVoucherComment();

  const openCommentEdit = () => {
    handleCommentEditOpen();
  };

  const handleSubmit = async () => {
    const payload = {
      pv: voucher.id,
      to: whoToRecieveComment,
      content: contentRef.current?.resizableTextArea?.textArea?.value,
      commentId: comment.id,
    };
    const { message: response } = await updateVoucher(payload);
    setFlag(!flag);
    message.success("Comment updated successfully");
    handleCommentEditClose();
  };

  const currentUser = userStore((state) => state.user);
  return (
    <>
      <div>
        <Button
          onClick={openCommentEdit}
          disabled={!currentUser?.roles?.includes(comment.sender)}
          type="primary"
        >
          <EditOutlined />
          Edit
        </Button>
      </div>
      <Modal
        centered
        title="Edit Comment"
        footer={null}
        onCancel={handleCommentEditClose}
        open={isCommentEditOpen}
      >
        <Form initialValues={{ ...comment }}>
          <Form.Item name="receiver">
            <Select
              placeholder="select who to comment on"
              onChange={(e) => setWhoToRecieveComment(e)}
            >
              {Array.from(new Set(voucher.approvedBy))?.map((role, idx) => (
                <Option key={idx} value={role}>
                  {role}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="content">
            <TextArea
              ref={contentRef}
              placeholder="Your comments"
              autoSize={{
                minRows: 3,
                maxRows: 7,
              }}
            />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              span: 8,
              offset: 18,
            }}
            style={{ marginTop: "1em" }}
          >
            <Button type="primary" onClick={handleSubmit}>
              <SendOutlined />
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default CommentEdit;